var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAktiviDobavyaneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.64,9.6l6.72,9.6H2.88L8.64,9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,8.64h3.84v3.84H0V8.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.44,4.8c1.59,0,2.88,1.29,2.88,2.88s-1.29,2.88-2.88,2.88c-1.59,0-2.88-1.29-2.88-2.88S11.85,4.8,13.44,4.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.2,8.64h1.92v2.88H24v1.92h-2.88v2.88H19.2v-2.88h-2.88v-1.92h2.88V8.64z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAktiviDobavyaneIcon);
export default __webpack_public_path__ + "static/media/aktivi_dobavyane_icon.3abd2262.svg";
export { ForwardRef as ReactComponent };